import React, { useState } from 'react';
import { Review } from '../style';
import { Formik, Form } from 'formik';
import { Text } from '@design-system/Text';
import { Button } from '@design-system/Button';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { update_order_review } from '../redux/reducer';
import toast from 'react-hot-toast';

const OrderReview = ({ review, close }) => {
  const [rating, setRating] = useState(0);
  const dispatch = useDispatch();

  const handleClick = (selectedRating) => {
    setRating(selectedRating);
  };

  let data = {
    comment: '',
  };

  const handleSubmit = (doc) => {
    if (rating >= 1) {
      let data = {
        ...doc,
        rating: rating,
      };
      dispatch(update_order_review({ id: review?._id, data }));
    } else {
      toast.error('Please give a rating!!!');
    }
  };
  return (
    <Review>
      <Text size="small" align="center" fs="18px" weight="500" color="#333333">
        How was your order from {review?.partner?.business_name}?
      </Text>

      <div className="star_container">
        {[1, 2, 3, 4, 5].map((star) => (
          <span
            key={star}
            className={star <= rating ? 'star filled' : 'star'}
            onClick={() => handleClick(star)}
          >
            &#9733;
          </span>
        ))}
      </div>

      <Formik initialValues={data} onSubmit={handleSubmit}>
        {({ values, handleChange, dirty }) => (
          <Form>
            <Text
              mt="19px"
              align="left"
              fs="14px"
              weight="500"
              size="small"
              color="#333333"
            >
              Add a written review
            </Text>
            <textarea
              rows="5"
              placeholder="What did you like or dislike?"
              name="comment"
              value={values.comment}
              onChange={handleChange}
            />

            <Button
              width="100%"
              disabled={!dirty}
              type="submit"
              text="Send Review"
              weight="700"
              bgColor="#549A9A"
            />
            <Button
              width="100%"
              mt="12px"
              border="1px solid #E0E0E0"
              bgColor="#fff"
              color="#333333"
              text="Cancel"
              weight="700"
              onClick={close}
            />
          </Form>
        )}
      </Formik>
    </Review>
  );
};

export default OrderReview;

OrderReview.propTypes = {
  review: PropTypes.object.isRequired,
  close: PropTypes.func,
};

OrderReview.defaultProps = {
  close: () => {},
};
